import React from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import type { AuthProviderProps } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { config } from './config';
import { App } from './App';
import './styles.css';

const oidcConfig: AuthProviderProps = {
  authority: config.cognitoAuthority,
  client_id: config.cognitoClientId,
  redirect_uri: config.redirectUri,
  post_logout_redirect_uri: config.redirectUri,
  response_type: 'code',
  scope: 'openid email profile',
  // Survives a page reload so a refresh does not bounce the user to Cognito.
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  // The in-flight login state defaults to sessionStorage, which is empty if the
  // redirect lands in a different tab - the "No matching state found in storage"
  // failure. localStorage survives that; oidc-client-ts deletes the entry on use.
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
  // Drop ?code=...&state=... from the address bar after the redirect.
  onSigninCallback: () => window.history.replaceState({}, '', window.location.pathname),
};

const container = document.getElementById('root');
if (!container) throw new Error('Root element not found');

createRoot(container).render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>,
);
